import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  headers = new HttpHeaders().set('Content-Type', 'text/xml').set('Accept', 'text/xml');

  constructor(private http: HttpClient) { }

  getProducerInfo() {
    let httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'Authorization': `Basic ` + btoa('nira:Passw0rd'),
        }
      )
    };
    return this.http.get(`${environment.didlookup_endpoint}/view/${environment.epcid}`, httpOptions);
  }

  getPartnersInfo(): Observable<any[]> {
    let httpOptions = {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'Authorization': `Basic ` + btoa('nira:Passw0rd'),
        }
      )
    };
    return this.http.get<any[]>(`${environment.didlookup_endpoint}/viewpartners/${environment.epcid}`, httpOptions);
  }

  getDidDocument(did: string): Observable<any> {
    return this.http.post(`${environment.didresolve_endpoint}/agent/resolveDid`, { "didUrl": did } );
  }

  // get event data from epcis db
  // getEventData(epcis: string): Observable<any> {
  //   return this.http.get<any[]>(`${environment.epcis_event_endpoint}${epcis}`);
  // }
  getEventData(epcis: string): Observable<any> {
    let xml = '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">' + 
    '<soapenv:Header/>' + 
    '<soapenv:Body>' + 
	  '<query:Poll xmlns:query="urn:epcglobal:epcis-query:xsd:1">' + 
	  '<queryName>SimpleEventQuery</queryName>' + 
	  '<params>' + 
    '<param>' + 
    '<name>MATCH_anyEPC</name>' + 
    '<value xsi:type="query:ArrayOfString">' + 
    '<string>' + epcis + '</string>' + 
    '</value>' + 
    '</param>' + 
    '</params>' + 
	  '</query:Poll>' + 
    '</soapenv:Body>' +
    '</soapenv:Envelope>'

    return this.http.post(environment.epcis_endpoint, xml, {headers: this.headers, responseType:'text'});
  }

  // get object event data for trucks involved 
  // getObjectEventData(epcis: string, startTime: string, endTime: string) {
  //   return this.http.get<any[]>(`${environment.epcis_event_endpoint}${epcis}&eventType=ObjectEvent&GE_eventTime=${startTime}&LT_eventTime=${endTime}`);
  // }
  getObjectEventData(epcis: string, startTime: string, endTime: string) {
    let xml = '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:query="urn:epcglobal:epcis-query:xsd:1" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">'+
    '<soapenv:Header/>'+
    '<soapenv:Body>'+
    '<query:Poll>'+
    '<queryName>SimpleEventQuery</queryName>'+
    '<params>'+
    '<param>'+
    '<name>MATCH_anyEPC</name>'+
    '<value xsi:type="query:ArrayOfString">'+
    '<string>'+ epcis + '</string>'+
    '</value>'+
    '</param>'+
    '<param>'+
    '<name>eventType</name>'+
    '<value xsi:type="query:ArrayOfString">'+
    '<string>ObjectEvent</string>'+
    '</value>'+
    '</param>'+
    '<param>'+
    '<name>GE_eventTime</name>'+
    '<value xsi:type="xsd:dateTime">'+ startTime +'</value>'+
    '</param>'+
    '<param>'+
    '<name>LT_eventTime</name>'+
    '<value xsi:type="xsd:dateTime">'+ endTime + '</value>'+
    '</param>'+
    '</params>'+
    '</query:Poll>'+
    '</soapenv:Body>'+
    '</soapenv:Envelope>'

    return this.http.post(environment.epcis_endpoint, xml, {headers: this.headers, responseType:'text'})
  }

  // get master data from epcis db
  getMasterData(): Observable<any> {
    let xml = '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:query="urn:epcglobal:epcis-query:xsd:1">'+
    '<soapenv:Header/>'+
    '<soapenv:Body>'+
    '<query:Poll>'+
    '<queryName>SimpleMasterDataQuery</queryName>'+
    '<params>'+
    '<param>'+
    '<name>HASATTR</name>'+
    '<value xsi:type="query:ArrayOfString">'+
    '<string>bizLocationName</string>'+
    '</value>'+
    '</param>'+
    '<param>'+
    '  <name>includeAttributes</name>'+
    '  <value xsi:type="xsd:boolean">true</value>'+
    '</param>'+
    '<param>'+
    '  <name>includeChildren</name>'+
    '  <value xsi:type="xsd:boolean">true</value>'+
    '</param>'+
    '</params>'+
    '</query:Poll>'+
    '</soapenv:Body>'+
    '</soapenv:Envelope>'

    return this.http.post(environment.epcis_endpoint, xml, {headers: this.headers, responseType:'text'})
    // headers.append('Content-Type', 'application/xml');
    // headers.append('Accept', 'application/xml');

    // return this.http.post(environment.epcis_masterdata_endpoint, xml, this.httpOptions);
    // return this.http.get<any[]>(environment.epcis_masterdata_endpoint);
    // let xmlhttp = new XMLHttpRequest();
    // xmlhttp.open("POST", "http://dev.nira-inc.com/epcis/query");
    // var xmlDoc;
    // xmlhttp.onreadystatechange = (() => {
    //   if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
    //     xmlDoc = xmlhttp.responseXML;
    //     console.log(xmlDoc);
    //     // return xmlDoc;
    //   }
    // })
    // xmlhttp.setRequestHeader('Content-Type', 'application/xml');
    // xmlhttp.send(xml);
  }
}
